import { apiClient } from './client';
import type { PlaybooksResponse } from '../types';

export const playbooksApi = {
  async list(): Promise<PlaybooksResponse> {
    const { data } = await apiClient.get<PlaybooksResponse>('/playbooks');
    return data;
  },
};
